import styles from './ProductCardNonBuyable.module.scss';
import React from 'react';
import classNames from 'classnames';
import {
  Button,
  FontAwesomeProIcon,
  Heading,
  Link,
} from '@wienenergiegithub/ui-next';

const ProductCardNonBuyableLegacy = ({
  small = false,
  title,
  subtitle,
  phone,
  standalone,
}) => (
  <div
    className={classNames(styles.nonBuyableWrapper, {
      [styles.standalone]: standalone,
    })}
  >
    <div className={styles.nonBuyableClaim}>
      <span
        className={classNames(styles.cardPrice, {
          [styles.cardPriceSmall]: small,
        })}
      >
        {title}
      </span>
    </div>
    <Button
      aria-label={`${subtitle} ${phone}`}
      className={styles.nonBuyableAction}
      render={<Link to={`tel:${phone}`} />}
      shape="squared"
      theme="ghost"
      variant="link"
    >
      <Heading as="span" noSpacing size="h7" theme="neutral">
        <FontAwesomeProIcon
          className={styles.nonBuyableActionIcon}
          fixedWidth
          icon="phone"
          role="presentation"
          type="solid"
        />
        {phone}
      </Heading>
    </Button>
  </div>
);

export default ProductCardNonBuyableLegacy;
